module.exports = __webpack_public_path__ + "img/lampa.e1bc4820.jpg";